import { MatButtonModule } from "@angular/material/button";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {
  ElementRef,
  Component,
  QueryList,
  ViewChildren,
  Input, OnInit
} from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { LoadingController, AlertController, ModalController, ToastController } from '@ionic/angular';
import { ApplicationService } from 'src/app/services/application/application.service';
import { CommonService } from 'src/app/services/common/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Errors } from 'src/app/core/model/error.model';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],

})
export class ConfirmationComponent implements OnInit {

  DDID: string | null = null;
  investmentId: string | null = null;
  signerEmail: string | null = null;
  digioUrl: string | null = null;
  isChecked: boolean = false;

  constructor(
    private modalController: ModalController,
    private router: Router,
    private route: ActivatedRoute,
    private applicationService: ApplicationService,
    private commonService: CommonService,
    private alertController: AlertController,
    private readonly loadingController: LoadingController,
    private readonly dropdownService: DropdownService,
    private readonly toastController: ToastController,
    private readonly sanitizer: DomSanitizer,

  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log(params['DID']);
      console.log(params['ID']);
      console.log(params['email']);
      this.DDID = params['DID'];
      this.investmentId = params['ID'];
      this.signerEmail = params['email'];
    });
    // this.DDID = this.route.snapshot.paramMap.get('DDID');
    // this.investmentId = this.route.snapshot.paramMap.get('investmentId');
    // this.signerEmail = this.route.snapshot.paramMap.get('signerEmail');
    this.digioUrl = environment.DIGIO_URL + this.DDID + "/" + this.investmentId + "/" + this.signerEmail;
  }

  redirect() {
    window.location.href = this.digioUrl;
  }

  changed(evt) {
    this.isChecked = evt.target.checked;
  }
}
